import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c8901f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-administrative-data" }
const _hoisted_2 = { class: "flex justify-center" }
const _hoisted_3 = {
  id: "formCompanyAddress",
  class: "flex items-center flex-col rounded overflow-hidden"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "titleBold text-left" }, "Endereço", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " O e-mail informado em \"Dados Pessoais\" será utilizado para realizar o acesso a nossa Plataforma e o e-mail em \"Dados Administrativos\" será utilizado para contato. ", -1))
const _hoisted_6 = { class: "input w-full" }
const _hoisted_7 = { class: "input w-full" }
const _hoisted_8 = { class: "two-inputs input w-full" }
const _hoisted_9 = { class: "input-1" }
const _hoisted_10 = { class: "input-2" }
const _hoisted_11 = { class: "input w-full" }
const _hoisted_12 = { class: "two-inputs input w-full" }
const _hoisted_13 = { class: "input-1" }
const _hoisted_14 = { class: "input-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Input = _resolveComponent("Input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_Input, {
            "v-model": _ctx.cep,
            onInput: _ctx.onChangeCep,
            isError: _ctx.isErrorCep,
            errorMessage: "CEP inválido!",
            width: "100%",
            label: "CEP",
            "data-testid": "signup-cep-input",
            pattern: "^[0-9]{5}-[0-9]{3}$",
            mask: "#####-###",
            required: ""
          }, null, 8, ["v-model", "onInput", "isError"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_Input, {
            isError: _ctx.isErrorStreet,
            onInput: _ctx.onChangeStreet,
            errorMessage: "Rua inválida",
            width: "100%",
            label: "Rua / Avenida / Travessa",
            "data-testid": "signup-street-input",
            value: _ctx.street,
            required: ""
          }, null, 8, ["isError", "onInput", "value"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_Input, {
              isError: _ctx.isErrorNumber,
              onInput: _ctx.onChangeNumber,
              errorMessage: "Numero Inválido.",
              width: "100%",
              label: "Número",
              "data-testid": "signup-number-input",
              value: _ctx.number,
              required: ""
            }, null, 8, ["isError", "onInput", "value"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_Input, {
              isError: _ctx.isErrorDistrict,
              onInput: _ctx.onChangeDistrict,
              errorMessage: "Bairro inválido!",
              width: "100%",
              label: "Bairro",
              "data-testid": "signup-district-input",
              value: _ctx.district,
              required: ""
            }, null, 8, ["isError", "onInput", "value"])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_Input, {
            "v-model": _ctx.complement,
            onInput: _ctx.onChangeComplement,
            isError: _ctx.isErrorComplement,
            errorMessage: "Complemento inválido!",
            width: "100%",
            label: "Complemento",
            "data-testid": "signup-complement-input",
            required: ""
          }, null, 8, ["v-model", "onInput", "isError"])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_Input, {
              isError: _ctx.isErrorState,
              onInput: _ctx.onChangeState,
              errorMessage: "Estado Inválido, use as siglas. Ex: SP",
              width: "100%",
              label: "UF",
              "data-testid": "signup-state-input",
              pattern: "^(\\s*(AC|AL|AP|AM|BA|CE|DF|ES|GO|MA|MT|MS|MG|PA|PB|PR|PE|PI|RJ|RN|RS|RO|RR|SC|SP|SE|TO)?)$",
              value: _ctx.state,
              mask: "AA",
              required: ""
            }, null, 8, ["isError", "onInput", "value"])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_Input, {
              isError: _ctx.isErrorCity,
              onInput: _ctx.onChangeCity,
              errorMessage: "Cidade inválida!",
              width: "100%",
              label: "Cidade",
              "data-testid": "signup-city-input",
              value: _ctx.city,
              required: ""
            }, null, 8, ["isError", "onInput", "value"])
          ])
        ])
      ])
    ])
  ]))
}